module.exports = __webpack_public_path__ + "img/92117.64baf843.svg";